export default "__VITE_ASSET__DX8SzD6E__"